export default (ctx, html) => html`
  <slot name="modal-header-text"></slot>
  <slot name="modal-focus"></slot>
  <slot name="modal-close-button"></slot>
  <slot name="modal-content"></slot>
`;
